// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"502":"servicios","559":"beneficio","594":"about","900":"contacto","962":"home"}[chunkId] || chunkId) + "." + {"502":"f5b0040f","553":"76ce3f06","559":"5fcd7b37","594":"2b18ff0e","669":"c09ea034","900":"59f24a3b","962":"aed8b7e7"}[chunkId] + ".js";
};